import React from "react";

import MiniDrawer from "../components/drawer";
import SupervisorHome from "../components/supervisor-home";
import useSupervisorHomeEnabled from "../components/supervisor-home/controllers/use-supervisor-home-enabled";

// "/" is the supervisor landing page once supervisorDashboardEnabled is on.
// Until then it keeps rendering the flex scheduler, as it always has.
export default function DetectHome() {
	const isSupervisorHomeEnabled = useSupervisorHomeEnabled();

	if (isSupervisorHomeEnabled) {
		return <SupervisorHome />;
	}

	return <MiniDrawer />;
}
